import { Button, Flex } from "@qws-org/ui-kit";
import type { FC } from "react";

import type {
  ActionActionItemUnion,
  ExternalNavigation,
  InternalNavigation,
} from "~/core";

import type { BannerVariant, MainBannerV2Props } from "../MainBannerV2";

type MainBannerButtonsProps = MainBannerV2Props & {
  bannerVariant?: BannerVariant;
};

const isExternalLink = (
  action: ActionActionItemUnion | null | undefined,
): action is ExternalNavigation => {
  return "href" in (action ?? {});
};
const isInternalLink = (
  action: ActionActionItemUnion | null | undefined,
): action is InternalNavigation => {
  return "page" in (action ?? {});
};
export const MainBannerButtons: FC<MainBannerButtonsProps> = ({
  data,
  getUrl,
  bannerVariant = "column",
  onCallAction,
  isControlInactive,
}) => {
  return (
    <Flex
      align="center"
      justify="center"
      gap={bannerVariant === "column" ? 8 : 16}
      md={{
        justify: bannerVariant === "row" ? "flex-start" : "center",
        m: { mt: 0 },
      }}
      d={{ gap: bannerVariant === "column" ? 24 : 16 }}
      m={{ mt: "auto" }}
    >
      {data.controls
        ?.filter((control) => {
          if (control?.main_banner_controls_id?.action) {
            return !isControlInactive(control.main_banner_controls_id.action);
          }

          return true;
        })
        .map((control, idx) => {
          const controlAction = control?.main_banner_controls_id?.action;
          const action = controlAction?.action?.[0];
          let href;
          if (isExternalLink(action?.item)) {
            href = action.item.href ?? undefined;
          }
          if (isInternalLink(action?.item)) {
            href = action.item.page ? getUrl(action.item.page) : undefined;
          }
          return (
            <Button
              horizontalAlign="center"
              href={href}
              key={control?.id}
              variant={
                control?.main_banner_controls_id?.variant === "primary"
                  ? "default"
                  : "transparent"
              }
              size="small"
              fontWeight="desktop.bold"
              md={{
                p: 18,
                minWidth: bannerVariant === "row" ? 215 : 240,
                fontSize: "button.desktop.medium",
                lineHeight: "button.desktop.medium",
              }}
              onPress={() => {
                if (controlAction) {
                  onCallAction(controlAction);
                }
              }}
              p={12}
              minWidth={bannerVariant === "row" ? 148 : 160}
              data-testid={`main-banner-button-${idx}`}
            >
              {control?.main_banner_controls_id?.text}
            </Button>
          );
        })}
    </Flex>
  );
};
